import { Reducer } from 'redux';
import { IErrorsAction, IErrorsState } from './ErrorsModel';

const initialState: IErrorsState = [];

export const errors: Reducer<IErrorsState, IErrorsAction> = (
    state = initialState,
    action
) => {
    switch (action.type) {
        case 'FETCH_ERRORS_REQUEST':
            return {
                ...state,
                loading: true,
                error: null,
            };
        case 'FETCH_ERRORS_SUCCESS':
            return {
                ...state,
                loading: false,
                errors: action.payload,
            };
        case 'FETCH_ERRORS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.error,
            };
        case 'FETCH_ERRORS_DOWNLOAD_REQUEST':
            return {
                ...state,
                downloadInProgress: true,
                downloadError: null,
            };
        case 'FETCH_ERRORS_DOWNLOAD_SUCCESS':
            return {
                ...state,
                downloadInProgress: false,
                downloadError: null,
            };
        case 'FETCH_ERRORS_DOWNLOAD_FAILURE':
            return {
                ...state,
                downloadInProgress: false,
                downloadError: action.error,
            };
        default:
            return state;
    }
};
